import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { itemObject } from 'src/interface/book';

@Injectable({
    providedIn: 'root'
})
export class CartService {
    private itemsInCartSubject = new BehaviorSubject<number>(0);
    public itemsInCart$ = this.itemsInCartSubject.asObservable();

    private items: itemObject[] = [];

    addItem(item: itemObject) {
        // Check if item is already in cart
        const existingItem = this.items.find(i => i.id === item.id);
        if (existingItem) {
            // If item is already in cart, check if quantity < 5
            if (existingItem.quantity < 5) {
                existingItem.quantity++;
            } else {
                // console.log('You have reached the maximum quantity for this item.');
            }
            if (this.items.length > 15) {
                // console.log('You have reached the maximum item count.');
                // Remove the last added item
                const lastAddedItem = this.items[this.items.length - 1];
                if (lastAddedItem.quantity > 1) {
                    // If the last added item has a quantity > 1, decrease its quantity by 1
                    lastAddedItem.quantity--;
                } else {
                    // If the last added item has a quantity = 1, remove it from the cart
                    const index = this.items.indexOf(lastAddedItem);
                    if (index > -1) {
                        this.items.splice(index, 1);
                    }
                }
            }
        } else {
            // If item is not in cart, add it with quantity = 1
            item.quantity = 1;
            this.items.push(item);
        }

        // Check if the total item count exceeds 15


        // Update cart count
        this.updateTotals();
    }

    removeItem(item: itemObject) {
        const index = this.items.indexOf(item);
        if (index > -1) {
            this.items.splice(index, 1);
            // Update cart count
            this.updateTotals();
        }
    }

    getItems() {
        return this.items;
    }

    getItemsCount() {
        return this.items.length;
    }

    private updateTotals() {
        let totalQuantity = 0;
        // let totalPrice = 0;
        for (const item of this.items) {
            totalQuantity += item.quantity;
            // totalPrice += item.price * item.quantity;
        }
        this.itemsInCartSubject.next(totalQuantity);
    }
}
